import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import * as enTranslations from '../assets/i18n/en.json';

@Injectable({
  providedIn: 'root'
})
export class TranslateService {
  private currentLang: string = 'en';
  private translationCache: Record<string, string> = {};
  
  languageChanged = new Subject<string>();
  isLoaded = new BehaviorSubject<boolean>(false);

  constructor() {
    this.initializeLanguage();
  }

  get(): string {
    return this.currentLang;
  }

  instant(key: string): string {
    if (this.translationCache[key]) {
      return this.translationCache[key];
    }
    
    const translation = (enTranslations as any)[key] || key;
    this.translationCache[key] = translation;
    return translation;
  }

  async initializeLanguage(): Promise<void> {
    this.currentLang = 'en';
    // Előre cache-eljük a leggyakrabban használt fordításokat
    Object.keys(enTranslations).forEach(key => {
      this.translationCache[key] = (enTranslations as any)[key];
    });
    this.isLoaded.next(true);
  }

  async use(lang: string): Promise<void> {
    this.currentLang = 'en';
    this.languageChanged.next('en');
  }
}
